<template>
    <div class="InputReadOne">
        <div class="select_input">
            <span class="label_name" :class="isMust?'isMust':''">{{name}}</span>
            <span class="input_sty">{{value1}}</span>
        </div>
    </div>
</template>

<script>

  export default {
    name:"InputReadOne",
    data(){
        return{
            // data:this.value.FullName||this.value,
            value1:this.value
        }
    },
    methods:{

    },
    props:{
        // 默认数据值
        value:[String,Object,Number],
        // lable名称
        name: {
            type: String,
            default: "客户"
        },
        // 是否必填
        isMust:{
            type: Boolean,
            default: true
        },
    },
    watch:{
        // 监听客户数据变化
        value:{
            handler(newValue, oldValue) {
                this.value1 = newValue;
            },
            deep: true
        },
    },
    created(){

    },
  }
</script>

<style lang="less">
.InputReadOne{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    background: #f5f5f5;
    .select_input{
        width: 100%;
        height: 30px;
        display: -webkit-box !important;
        display: box !important;
        position:relative;
        -webkit-box-align:center;
        box-align:center;
        color: #666;
        border: 1px solid #d6e2ed;
        border-radius: 5px;
        padding: 0 5px;
        box-sizing: border-box;
        .label_name{
            height: 100%;
            line-height: 30px;
            font-size: 12px;
            color: inherit;
            font-weight: bold;
        }
        .input_sty{
            position:relative;
            display: block;
            height: 100%;
            width: 83%;
            line-height: 30px;
            font-size: 12px;
            padding-left: 5px;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/InputReadOne/InputReadOne.vue